export const getFileExtension = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf(".");
  // No dot, dot is first character, or dot is last character -> no extension
  if (lastDotIndex <= 0 || lastDotIndex === filename.length - 1) {
    return "";
  }
  return filename.slice(lastDotIndex + 1).toLowerCase();
};
